import { RouteContextType } from "../../hooks/use-route-context/UseRouteContext";
import { IRoute, routes, routesByViewID } from "../../routes/routes";
import { UIViewEnum } from "../enums/UIViewEnum";

// All Route Types
// =====================
// group
// group/well
// group/well/tag
// group/well/device
// group/well/device/tag
// group/device
// group/device/tag
// group/device/tank
// group/device/tank/tag
// group/tankbattery
// group/tankbattery/tag
// group/tankbattery/tank
// group/tankbattery/tank/tag



// Group Routes
// =====================
// group
export function getGroupRoute(view: UIViewEnum, groupID: number) {
    const route = routesByViewID.get(view);
    return `${route?.fullPath}?groupID=${groupID}`;
}

// Device Routes
// =====================
// group/device
// group/well/device
export function getDeviceRoute(view: UIViewEnum, groupID?: number, wellID?: number, deviceID?: number, isPhone?: boolean) {

    let viewID = view;
    

    if (viewID === UIViewEnum.Device_ManualEntry && !isPhone) {
        viewID = UIViewEnum.Device_GaugeSheet;
    }
    
    
    const route = routesByViewID.get(viewID);


    return wellID
        ? `${route?.fullPath}?groupID=${groupID}&wellID=${wellID}&deviceID=${deviceID}`
        : `${route?.fullPath}?groupID=${groupID}&deviceID=${deviceID}`;
}

// Tank Routes
// =====================
// group/device/tank
// group/tankbattery/tank
// group/tank
export function getTankRoute(view: UIViewEnum, groupID?: number, deviceID?: number, tankBatteryID?: number, tankID?: number) {
    const route = routesByViewID.get(view);
    return tankBatteryID
        ? `${route?.fullPath}?groupID=${groupID}&tankBatteryID=${tankBatteryID}&tankID=${tankID}`
        : deviceID
            ? `${route?.fullPath}?groupID=${groupID}&deviceID=${deviceID}&tankID=${tankID}`
            : `${route?.fullPath}?groupID=${groupID}&tankID=${tankID}`;
}

// Well Routes
// =====================
// group/well
export function getWellRoute(view: UIViewEnum, groupID?: number, wellID?: number) {
    const route = routesByViewID.get(view);
    return `${route?.fullPath}?groupID=${groupID}&wellID=${wellID}`;
}

// Tank Battery Routes
// =====================
// group/tankbattery
export function getTankBatteryRoute(view: UIViewEnum, groupID?: number, tankBatteryID?: number){
    const route = routesByViewID.get(view);
    return `${route?.fullPath}?groupID=${groupID}&tankBatteryID=${tankBatteryID}`;
}

// Tag Routes
// =====================
// group/well/tag
// group/well/device/tag
// group/device/tag
// group/device/tank/tag
// group/tankbattery/tag
// group/tankbattery/tank/tag
// group/tank/tag
export function getTagRoute(view: UIViewEnum, groupID?: number, wellID?: number, deviceID?: number, tankBatteryID?: number, tankID?: number, tagID?: number) {
    const route = routesByViewID.get(view);
    return deviceID && wellID
        ? `${route?.fullPath}?groupID=${groupID}&wellID=${wellID}&deviceID=${deviceID}&tagID=${tagID}`
        : deviceID && tankID
            ? `${route?.fullPath}?groupID=${groupID}&deviceID=${deviceID}&tankID=${tankID}&tagID=${tagID}`
            : tankBatteryID && tankID
                ? `${route?.fullPath}?groupID=${groupID}&tankBatteryID=${tankBatteryID}&tankID=${tankID}&tagID=${tagID}`
                : deviceID
                    ? `${route?.fullPath}?groupID=${groupID}&deviceID=${deviceID}&tagID=${tagID}`
                    : wellID
                        ? `${route?.fullPath}?groupID=${groupID}&wellID=${wellID}&tagID=${tagID}`
                        : tankBatteryID
                            ? `${route?.fullPath}?groupID=${groupID}&tankBatteryID=${tankBatteryID}&tagID=${tagID}`
                            : tankID
                                ? `${route?.fullPath}?groupID=${groupID}&tankID=${tankID}&tagID=${tagID}`
                                : `${route?.fullPath}?groupID=${groupID}&tagID=${tagID}`;
}

export function getViewIDFromPath(path: string, defaultView: UIViewEnum): UIViewEnum {
    return routes.find(o => o.fullPath === path)?.viewID ?? defaultView;
}

export function getParentViewIDFromPath(path: string, defaultView: UIViewEnum): UIViewEnum {

    const route = routes.find(o => o.fullPath === path)
    return route?.parentViewID ?? route?.viewID ?? defaultView;
    //return routes.find(o => o.fullPath === path)?.parentViewID ?? defaultView;
}


export function getRouteFromPath(path: string): IRoute | undefined {
    return routes.find(o => o.fullPath === path);    
}

export function getRouteFromContext(view: UIViewEnum, routeContext: RouteContextType) {
    const route = routesByViewID.get(view);

    let result = `${route?.fullPath}?groupID=${routeContext.groupID}`;

    if(routeContext.wellID){
        result = `${result}&wellID=${routeContext.wellID}`;
    }
    if(routeContext.deviceID){
        result = `${result}&deviceID=${routeContext.deviceID}`;
    }
    if(routeContext.tankBatteryID){
        result = `${result}&tankBatteryID=${routeContext.tankBatteryID}`;
    }
    if(routeContext.tankID){
        result = `${result}&tankID=${routeContext.tankID}`;
    }
    if(routeContext.tagID){
        result = `${result}&tagID=${routeContext.tagID}`;
    }
    
    return result;    

}




// SPR - Alternative to all of the above. This would involve a lot of extra string copying, but could theoretically handle any type of route.
// function makeRoute(view: UIViewEnum, groupID?: number, wellID?: number, deviceID?: number, tankBatteryID?: number, tankID?: number, tagID?: number) {
//     const route = routes.find(o => o.viewID === view);        
//     let result = `${route?.fullPath}?groupID=${groupID}`;

//     if(wellID){
//         result = `${result}&wellID=${wellID}`;
//     }
//     if(deviceID){
//         result = `${result}&deviceID=${deviceID}`;
//     }
//     if(tankBatteryID){
//         result = `${result}&tankBatteryID=${tankBatteryID}`;
//     }
//     if(tankID){
//         result = `${result}&tankID=${tankID}`;
//     }
//     if(tagID){
//         result = `${result}&tagID=${tagID}`;
//     }
    
//     return result;
// }
